import React from 'react';

interface RecipeIngredientCardItem {
  quantity?: string;
  name?: string;
}

interface RecipeIngredientCardsProps {
  items: RecipeIngredientCardItem[];
  emptyMessage?: string;
}

const normalizeIngredientText = (value: string): string =>
  value
    .replace(/\s+/g, ' ')
    .replace(/\(\s+/g, '(')
    .replace(/\s+\)/g, ')')
    .trim();

const getDisplayValue = (value: string | undefined): string => {
  if (!value) return '-';
  const normalized = normalizeIngredientText(value);
  return normalized.length > 0 ? normalized : '-';
};

const RecipeIngredientCards: React.FC<RecipeIngredientCardsProps> = ({
  items,
  emptyMessage = 'No ingredients available.',
}) => {
  if (!items.length) {
    return <p className="text-sm text-slate-500">{emptyMessage}</p>;
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(130px,1fr))] gap-3 sm:grid-cols-[repeat(auto-fill,minmax(145px,1fr))]">
      {items.map((item, index) => (
        <div
          key={`${item.name ?? 'ingredient'}-${index}`}
          className="flex min-h-[114px] flex-col items-center justify-center gap-2 rounded-[14px] border border-[#0000001A] bg-[#F9FAFB] px-3 py-3 text-center"
        >
          <p className="line-clamp-2 break-words text-[15px] font-semibold leading-tight text-slate-900">
            {getDisplayValue(item.quantity)}
          </p>
          <p className="line-clamp-3 break-words text-[12px] leading-tight text-slate-700">
            {getDisplayValue(item.name)}
          </p>
        </div>
      ))}
    </div>
  );
};

export default RecipeIngredientCards;
